import { useState } from 'react';
import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LwButton } from 'redesign';
import { IconAdd } from 'assets/img';
import { PartnerWorkerCla } from 'partner/shared/services/partner-worker-service.types';
import { AddClaDialog } from './add-cla-dialog';
import { ClaListTable } from './cla-list-table';

export type PartnerWorkerDetailClaViewProps = {
  workerId: string;
  clas: PartnerWorkerCla[];
};

export const PartnerWorkerDetailClaView = ({ workerId, clas }: PartnerWorkerDetailClaViewProps) => {
  const { t } = useTranslation('partner-screen-specific');
  const [isAddOpen, setIsAddOpen] = useState(false);

  return (
    <Wrapper>
      {clas.length === 0 ? (
        <EmptyStateText>
          {t('partner-worker-detail.cla-list.empty', { ns: 'partner-screen-specific' })}
        </EmptyStateText>
      ) : (
        <TableWrapper>
          <ClaListTable workerId={workerId} clas={clas} />
        </TableWrapper>
      )}
      <LwButton
        onClick={() => setIsAddOpen(true)}
        startIcon={<IconAdd />}
        color="primary"
        iconColorMode="fill"
      >
        {t('partner-worker-detail.cla-list.add-cla', { ns: 'partner-screen-specific' })}
      </LwButton>
      <AddClaDialog workerId={workerId} open={isAddOpen} onClose={() => setIsAddOpen(false)} />
    </Wrapper>
  );
};

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(4),
  marginTop: theme.spacing(2),
  justifyContent: 'space-between',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden',
}));

const EmptyStateText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const TableWrapper = styled(Box)({
  width: '100%',
  flex: '1 1 0',
  minHeight: 0,
  overflow: 'auto',
});
